import 'css-chunksrc/client/common/timeInput/styles.scss';export default {
  "timeInput": "_timeInput_gmz3u_1",
  "timePlaceholder": "_timePlaceholder_gmz3u_9",
  "timeValue": "_timeValue_gmz3u_14",
  "timeListWrapper": "_timeListWrapper_gmz3u_19",
  "timeList": "_timeList_gmz3u_19",
  "time": "_time_gmz3u_1",
  "timeName": "_timeName_gmz3u_40"
};